export const SERVER_AI_URL = import.meta.env.VITE_SERVER_AI_URL;
export const APP_URL = import.meta.env.VITE_APP_URL;
export const WEBSITE_URL = import.meta.env.VITE_WEBSITE_URL;
export const DATAFEED_API = import.meta.env.VITE_DATAFEED_API;
// WebSocket URL for the datafeed (Workbench chart). Use an explicit
// VITE_DATAFEED_WS if provided, otherwise derive it from DATAFEED_API by
// swapping the http(s) scheme for ws(s) and appending the WS path.
export const DATAFEED_WS =
  import.meta.env.VITE_DATAFEED_WS ||
  (DATAFEED_API
    ? `${DATAFEED_API.replace(/^http/, 'ws').replace(/\/+$/, '')}/datafeed/ws`
    : undefined);
export const COOKIE_DOMAIN = import.meta.env.VITE_COOKIE_DOMAIN;
export const CANNY_BOARD_TOKEN = import.meta.env.VITE_CANNY_BOARD_TOKEN;
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY;